module.exports = __webpack_public_path__ + "img/off-agenda.9a92bacb.svg";